export enum DictEnum {
  Countries = 'countries',
  Provinces = 'provinces',
  Cities = 'cities',
  Directions = 'directions',
  Degrees = 'school_degrees',
  Faculties = 'faculties',
  Specializations = 'specialities',
  Schools = 'schools',
  Skills = 'competences',
  Positions = 'positions',
  Companies = 'employers',
  CompaniesBlind = 'employers/blind',
  Certificates = 'certificates',
  Trainings = 'trainings',
  Domains = 'domains',
  CvTargets = 'cv_targets',
  EconomySectors = 'economy_sectors',
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/enums/dict.enum.ts